import type { InitOptions } from 'i18next'
import { DEFAULT_LANGUAGE, DEFAULT_NAMESPACE, NAMESPACES, PSEUDO_LOCALE, SUPPORTED_LANGUAGES } from './languages'

/**
 * Settings shared by the app (lazy-loaded resources) and the tests (all English resources up
 * front). Kept free of axios, PostHog and the store so setupTests can import it cheaply.
 */
export const baseInitOptions = ({ allowPseudo }: { allowPseudo: boolean }): InitOptions => ({
  fallbackLng: DEFAULT_LANGUAGE,
  supportedLngs: allowPseudo ? [...SUPPORTED_LANGUAGES, PSEUDO_LOCALE] : [...SUPPORTED_LANGUAGES],
  // Bare codes only: never look for 'fr-FR' files.
  load: 'currentOnly',
  nonExplicitSupportedLngs: false,
  ns: [DEFAULT_NAMESPACE],
  defaultNS: DEFAULT_NAMESPACE,
  fallbackNS: false,
  // Keys look like 'plan.compare.teacherRow': nested JSON objects.
  keySeparator: '.',
  nsSeparator: ':',
  returnEmptyString: false,
  interpolation: { escapeValue: false },
  react: {
    // Components that call useTranslation suspend until their namespace has loaded, so a key
    // never flashes on screen. index.tsx wraps the app in a <Suspense> boundary for this.
    useSuspense: true,
    bindI18n: 'languageChanged loaded',
  },
})

/** Every namespace the app knows, for preloading in tests and checks. */
export const ALL_NAMESPACES = [...NAMESPACES]
